import { render, staticRenderFns } from "./ChooseSearchPurchaseItem.vue?vue&type=template&id=c6723812&scoped=true"
import script from "./ChooseSearchPurchaseItem.vue?vue&type=script&lang=js"
export * from "./ChooseSearchPurchaseItem.vue?vue&type=script&lang=js"
import style0 from "./ChooseSearchPurchaseItem.vue?vue&type=style&index=0&id=c6723812&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6723812",
  null
  
)

export default component.exports